
const SET_ONLINE = (state, item) => {
  state.online = item
}

export default {
  SET_ONLINE
}
